export const CORRESPONDENCE_TYPE_MAPPER = {
  'AUDIT COMMENCEMENT DOCUMENTS': 'audit commencement documents',
  'REQUEST FOR INFORMATION': 'request for information',
  'PRELIMINARY FINDINGS': 'Preliminary findings',
  'FINALISATION ADVICE': 'Finalisation advice',
};
